import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import Thyrocareimg from '../assets/Thyrocare.jpg';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// Import required modules
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

const Thyrocare = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/packages");
  };

  const services = [
    {
      icon: "🩺",
      title: "Integrated Family Wellness",
      desc: "Access healthcare support, preventive care, and everyday wellness benefits — all in one plan.",
      bgColor: "bg-red-100"
    },
    {
      icon: "🔬",
      title: "Diagnostic Support",
      desc: "Partner-led health checkups and lab testing through trusted healthcare networks.",
      bgColor: "bg-purple-100"
    },
    {
      icon: "💊",
      title: "Medicine Access Support",
      desc: "Convenient pharmacy and medicine delivery support through partner platforms.",
      bgColor: "bg-teal-100"
    },
    {
      icon: "🌸",
      title: "Menstrual Wellness",
      desc: "Personalized period care designed around your flow, comfort, and lifestyle needs.",
      bgColor: "bg-pink-100"
    },
    {
      icon: "👨‍👩‍👧",
      title: "Family OPD & Preventive Care",
      desc: "Extended wellness benefits designed to support the health needs of the entire family.",
      bgColor: "bg-blue-100"
    },
    {
      icon: "✨",
      title: "Member Benefits",
      desc: "Exclusive savings, priority wellness access, and ongoing support across the Eveya ecosystem.",
      bgColor: "bg-orange-100"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <div className="max-w-7xl mx-auto px-5 py-12 flex flex-col items-center">
        
        {/* Text Content */}
        <div className="text-center max-w-3xl space-y-6 mb-10">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 tracking-tight">
            More Than a Subscription
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed">
            A connected wellness ecosystem designed to support women and families beyond period care.
          </p>
          
          <div 
            onClick={handleNavigation}
            className="cursor-pointer transition-transform duration-300 hover:scale-105 mt-8 inline-block"
          >
            <img 
              src={Thyrocareimg} 
              alt="Thyrocare Partnership" 
              className="w-full max-w-2xl drop-shadow-xl rounded-2xl" 
            />
          </div>
        </div>

        {/* Carousel Section */}
        <div className="w-full py-10 px-12">
          <Swiper
            modules={[Pagination, Autoplay, Navigation]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="pb-14" // Space for pagination dots
          >
            {services.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center h-full min-h-[250px] transition-all hover:shadow-md">
                  <div className={`${item.bgColor} p-4 rounded-full mb-5 text-2xl`}>
                    {item.icon}
                  </div>
                  <h3 className="font-bold text-gray-800 text-lg mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
{/* <div clsassName="max-w-3xl mx-auto text-center mt-12">
  <p className="text-xl text-gray-600 leading-relaxed italic">
          "Healthcare and wellness services are offered through partner networks and may vary based on partner policies, availability, and serviceable regions"
        </p>
</div> */}
        {/* Call to Action Button */}
        <button 
          onClick={handleNavigation}
          className="inline-flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white font-bold py-4 px-10 rounded-full text-lg transition-all shadow-lg hover:shadow-red-200 mt-4"
        >
          Book a Health Checkup
          <ArrowRight size={20} />
        </button>
      </div>

      {/* Optional: Customizing Swiper dots color */}
      <style dangerouslySetInnerHTML={{ __html: `
        .swiper-pagination-bullet-active {
          background: #ef4444 !important;
        }
      `}} />
    </div>
  );
};

export default Thyrocare;